import React from "react";
import SideBarADM from "../SideBarADM";
import { Link } from "react-router-dom";
import "../sidebarADM.css";
import { getDraftsmanUsers } from "../../../api/admin";
import { useQuery } from "react-query";
import { NRoundedButton, DashInput } from "../../../shared-components";
import useFilter from "./useFilter";
import { CardProfile } from "./CardProfile";


const SolicitCadProjetista = () => {
  // const [draftsmans, setDraftsmans] = useState([]);
  const { data: draftsmans, isLoading } = useQuery(
    "profiles-builds",
    getDraftsmanUsers
  );

  const {
    handleFilter,
    searchTerm,
    setSearchTerm,
    filteredProfiles,
    filter,
    setFilter,
  } = useFilter(draftsmans);

  if (isLoading) {
    return <></>;
  }

  const handleClearFilter = () => {
    setFilter("all");
  };

  return (
    <div className="cont-geral">
      <SideBarADM />
      <div className="btns-solict2">
        <Link to="/solicitacao-cadastro-admin">
          <button className="expo-btn1">expositor</button>
        </Link>
        <Link to="/solicitacao-cadastro-promotor">
          <button className="promotor-btn1">promotor</button>
        </Link>
        <Link to="/solicitacao-cadastro-montador">
          <button className="montador-btn1">montador</button>
        </Link>
        <Link to="/solicitacao-cadastro-projetista">
          <button className="proj-btn">projetistas</button>
        </Link>
        <div className="search-input-admin">
          <DashInput
            value={searchTerm}
            placeholder={"Busque por um termo..."}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <NRoundedButton
            title={"aprovado"}
            active={filter === "APROVADO"}
            color={"#ddcd1b"}
            onClick={() => handleFilter("APROVADO")}
          />
          <NRoundedButton
            title={"pendente"}
            active={filter === "PENDENTE"}
            color={"#ddcd1b"}
            onClick={() => handleFilter("PENDENTE")}
          />
          <NRoundedButton
            title={"reprovado"}
            active={filter === "REPROVADO"}
            color={"#ddcd1b"}
            onClick={() => handleFilter("REPROVADO")}
          />
          <NRoundedButton
            title={"mostrar todos"}
            color={"#ddcd1b"}
            onClick={handleClearFilter}
            active={filter === "all"}
          />
        </div>
      </div>
      <div className="multiple-options">
        {filteredProfiles.map((draftsman) => (
          <CardProfile
            key={draftsman.id}
            profile={draftsman}
            handleAccept={draftsman}
          />
        ))}
      </div>
    </div>
  );
};

export default SolicitCadProjetista;
